import CloudOffRoundedIcon from '@mui/icons-material/CloudOffRounded';
import { Alert, Box, Container, Paper, Stack, ThemeProvider, Typography } from '@mui/material';
import { memo } from 'react';
import CrmDashboardHeaderBar from './CrmDashboardHeaderBar';
import CrmDashboardTaskSection from './CrmDashboardTaskSection';
import {
  CONTENT_GRID_ITEM_SX,
  CONTENT_GRID_SX,
  CRM_DASHBOARD_THEME,
  PAGE_BACKGROUND,
  SURFACE_SX,
} from './crmDashboardStyles';

const CrmDashboardBlockedState = memo(function CrmDashboardBlockedState({
  isMobile = false,
  isTenantWideView = false,
}) {
  return (
    <ThemeProvider theme={CRM_DASHBOARD_THEME}>
      <Box sx={{ background: PAGE_BACKGROUND, minHeight: '100vh', py: { xs: 2.5, md: 4 } }}>
        <Container maxWidth="xl">
          <Stack spacing={2}>
            <CrmDashboardHeaderBar
              counts={{ overdue: 0, dueToday: 0, planned: 0 }}
              isMobile={isMobile}
              isTenantWideView={isTenantWideView}
              onRefresh={undefined}
              refreshDisabled
            />

            <Paper elevation={0} sx={{ ...SURFACE_SX, p: { xs: 1.75, md: 2 } }}>
              <Stack spacing={1}>
                <Alert severity="warning" icon={<CloudOffRoundedIcon fontSize="inherit" />}>
                  Fortnox connection required to load the CRM dashboard.
                </Alert>
                <Typography variant="body2" color="text.secondary">
                  {isTenantWideView
                    ? 'Reconnect Fortnox from the home page to restore tenant activity and planned work.'
                    : 'Reconnect Fortnox from the home page to restore your due work.'}
                </Typography>
              </Stack>
            </Paper>

            <Box sx={CONTENT_GRID_SX}>
              <Box sx={CONTENT_GRID_ITEM_SX}>
                <CrmDashboardTaskSection
                  compactEmpty={isMobile}
                  emptyMessage={
                    isTenantWideView
                      ? 'Tenant overdue CRM activities stay blocked while Fortnox cannot resolve customer data.'
                      : 'Your overdue CRM activities stay blocked while Fortnox cannot resolve customer data.'
                  }
                  title={isTenantWideView ? 'Overdue activities' : 'Overdue'}
                  tone="overdue"
                />
              </Box>
              <Box sx={CONTENT_GRID_ITEM_SX}>
                <CrmDashboardTaskSection
                  compactEmpty={isMobile}
                  emptyMessage="Activities due today stay blocked until Fortnox is connected again."
                  title={isTenantWideView ? 'Activities due today' : 'Due today'}
                  tone="today"
                />
              </Box>
              <Box sx={CONTENT_GRID_ITEM_SX}>
                <CrmDashboardTaskSection
                  compactEmpty={isMobile}
                  emptyMessage="Planned CRM activities stay blocked until Fortnox is connected again."
                  title="Planned activities"
                  tone="planned"
                />
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>
    </ThemeProvider>
  );
});

export default CrmDashboardBlockedState;
